/**
 * https://artof.pro © 2020
 * Supports ES6 syntax
 **/

import $ from 'jquery';
import { loadCaptcha, initCaptcha, execute as executeCaptcha } from './_recaptcha';
import initCheckoutForm from './_checkout';

window.$ = $;
window.jQuery = $;

$.loadCaptcha = loadCaptcha;
$.initCaptcha = initCaptcha;
document.loadCaptcha = loadCaptcha;
document.initCaptcha = initCaptcha;
document.executeCaptcha = executeCaptcha;
document.initCheckoutForm = initCheckoutForm;

// Format Price

$.formatPrice = (value, showCurrency = true) => {
  let price = parseFloat(value).toFixed(2);
  price = price.split('.');

  const isNegative = value < 0;
  const format = JSON.parse($('[name=price_format]').attr('content'));

  let integer = Math.floor(price[0]);
  if (isNegative) integer = integer * -1;
  integer = integer.toString().replace(/\B(?=(\d{3})+(?!\d))/g, format.groupSymbol);

  const val = `${integer}${format.precision ? `${format.decimalSymbol}${price[1]}` : ''}`;
  const output = showCurrency ? format.pattern.replace('%s', val) : val;

  return isNegative ? `-${output}` : output;
}

// extend function to display spinner over buttons & other
$.fn.toggleSpinner = function (param) {
  if (this.hasClass('loading') || param === false) {
    if (this.is('button')) {
      this.removeAttr('disabled');
    }
    this.removeClass('loading').find('.spinner').remove();

  } else {
    if (this.is('button')) {
      this.prop('disabled', true);
    }
    this.addClass('loading').append('<div class="spinner"><div/><div/><div/><div/><div/></div>');
  }

  return this;
}